module.exports = __webpack_public_path__ + "static/media/boat-middle.1144d69d.svg";